import { DentalChartEnum } from "requests";

export const DENTAL_CHART_OPTIONS = [
  { label: "Deciduous", value: DentalChartEnum.Deciduous },
  { label: "Adult", value: DentalChartEnum.Adult }
];
